/**
 * Patient Welcome Call — field-level effects.
 *
 * Migrated from: patient/patient-welcome-call-base.coffee
 *
 * Old validators → new effects:
 *   WelcomeCallScript → WelcomeCallScript
 *
 * Old handler init logic (set_default_value, set_welcome_packet_received)
 * is NOT migrated here — those are form-load side-effects that should be
 * handled via form `onInit` or a dedicated init effect if needed.
 */
import { buildApiUrl, fetchAPI } from "@neu/libui";
import type { FieldHandler } from "@neu/libui";

// ─── WelcomeCallScript ───────────────────────────────────────────────────────
// Old: DSLFx.Validators.WelcomeCallScript
// Trigger field: plan_link_id (or plan_id)
// Fetches override call script for the plan; falls back to default call script.
export const WelcomeCallScript: FieldHandler = (field, { form }) => {
	void (async () => {
		let planId = field.value?.id;
		if (!planId) {
			// Fallback: try to read plan_id from form (mirrors old snapshot_data logic)
			planId = form.getFieldState("plan_id")?.value?.id;
		}
		if (!planId) return;

		try {
			// Try override call script for the plan first
			const planAttachments = await fetchAPI(
				buildApiUrl(
					`/plan_attachment/list?sort=-id&_plan_id=eq:${planId}`
				)
			);
			const rows = Array.isArray(planAttachments)
				? planAttachments
				: (planAttachments?.data ?? []);
			const callScripts = rows.filter((d: any) =>
				d.flag.find((i: any) => i.name === "Call Script")
			);
			if (callScripts.length > 0) {
				form.setFieldState("welcome_call_script", (s) => {
					s.value = callScripts[0].plan_file;
				});
				return;
			}
		} catch {
			// Override not found — fall through to default
		}

		try {
			// Fallback: default call script
			const defaultData = await fetchAPI(
				buildApiUrl(
					`/file_attachment/list?sort=-id&_description=eq:Default Call Script`
				)
			);
			const defaultRows = Array.isArray(defaultData)
				? defaultData
				: (defaultData?.data ?? []);
			if (defaultRows.length > 0) {
				form.setFieldState("welcome_call_script", (s) => {
					s.value = defaultRows[0].file;
				});
			}
		} catch (err) {
			console.error(
				"WelcomeCallScript: Unable to fetch default welcome call script.",
				err
			);
		}
	})();
	return "";
};
